import { render, staticRenderFns } from "./WpItemsEditTabPermissions.vue?vue&type=template&id=2ed2e58b&"
import script from "./WpItemsEditTabPermissions.vue?vue&type=script&lang=js&"
export * from "./WpItemsEditTabPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports